import { DataService } from '@/config/dataService/dataService';

const TrueLayerService = {
  connectBank(payload = {}) {
    return DataService.post('api/truelayer/connect-bank', payload);
  },

  disconnectBank() {
    return DataService.delete('api/truelayer/disconnect-bank');
  },

  getProviders(countryCode = 'uk') {
    return DataService.get('api/truelayer/providers', {
      params: {
        country_code: countryCode,
      },
    });
  },

  getBanks() {
    return DataService.get('api/truelayer/banks');
  },

  getTransactions(accountId) {
    return DataService.get(`api/truelayer/transactions/${accountId}`);
  },
};

export default TrueLayerService;